export interface DateWindow {
  /** 1-12 */
  startMonth: number;
  startDay: number;
  endMonth: number;
  endDay: number;
}

/**
 * True if `date` falls within the window (inclusive), handling windows that
 * wrap across New Year's (e.g. Dec 26 -> Jan 2). Used by HolidayCalendar —
 * holidays are keyed to the real calendar, not simulated island time.
 */
export function isWithinDateWindow(date: Date, window: DateWindow): boolean {
  const value = (date.getMonth() + 1) * 100 + date.getDate();
  const start = window.startMonth * 100 + window.startDay;
  const end = window.endMonth * 100 + window.endDay;
  return start <= end ? value >= start && value <= end : value >= start || value <= end;
}
